import { useState, useCallback, useEffect } from 'react';
import { api } from '../services/apiClient';

export function useAuth() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Load user
    const loadUser = useCallback(async () => {
        try {
            setLoading(true);
            const data = await api.auth.me();
            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    // Login
    const login = useCallback(async () => {
        try {
            const res = await api.auth.loginUrl();
            console.log("res.url");
            console.log(res.url);
            window.location.href = res.url;
        } catch (err) {
            console.error('Login error:', err);
        }
    }, []);

    // Logout
    const logout = useCallback(async () => {
        try {
            await api.auth.logout();
            setUser(null);
            window.location.reload();
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        loadUser();
    }, [loadUser]);

    return {
        user,
        loading,
        login,
        logout,
        loadUser,
    };
}